module.exports = __webpack_public_path__ + "static/media/journalism.6c91ba18.png";